import cookies from 'js-cookie'

export default function handler() {

	cookies.remove('token')

	window.location.reload()

}